import { useSyncExternalStore } from 'react';
import type { AwayMode } from '@shared/types';

/**
 * Qué hacer al salir de la pantalla durante un partido (Ajustes):
 * "Pausar" (por defecto; solo aplica con un único humano) o "La CPU juega por mí".
 */
const KEY = 'sportsarena.awayMode';
let mode: AwayMode = (() => {
  try {
    return typeof window !== 'undefined' && localStorage.getItem(KEY) === 'cpu' ? 'cpu' : 'pause';
  } catch {
    return 'pause';
  }
})();
const listeners = new Set<() => void>();

export const getAwayMode = (): AwayMode => mode;
export const setAwayMode = (m: AwayMode): void => {
  mode = m;
  try {
    localStorage.setItem(KEY, m);
  } catch {
    /* sin almacenamiento */
  }
  listeners.forEach((l) => l());
};
export const useAwayMode = (): AwayMode =>
  useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    getAwayMode,
    getAwayMode
  );
